import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider, ISearchProviderField, ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {SalesAreaSearch} from "./SalesAreaSearch";
import * as _ from "lodash";
import {CustomerTypeSearch} from "./CustomerTypeSearch";
import {esWB_SalesOrg} from "../PA.Core/PAdbSchema";
import {Mdl} from "../PA";
const vUI_Customer_Search_Fields: {[id:string]: ISearchProviderField } =
    {
        WB_CUST_ID: {
            type: SearchProviderFieldType.number,
            renderOptions: { columnName: 'Customer WB Id',  columnResourceName: 'colCustWBId',      alignment: HorizAlignment.Center},
            domainOptions: { }
        },
        CUSTOMER_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: { columnName: 'Customer Id',     columnResourceName: 'colCustId',        alignment: HorizAlignment.Left},
            domainOptions: { maxLength: 50}
        },
        CUSTOMER_NAME: {
            type: SearchProviderFieldType.string,
            renderOptions: { columnName: 'Customer Name',   columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},
            domainOptions: { maxLength: 256}
        },
        CUSTOMER_TYPE: {
            type: SearchProviderFieldType.string,
            renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},
            domainOptions: { maxLength: 256,  search: CustomerTypeSearch, profileId: "default", searchCondition: {}}
        },
        WB_SALESAREA_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: { columnName: 'Sales Area WB Id',  columnResourceName: 'colCustSARWBId', alignment: HorizAlignment.Center},
            domainOptions: { maxLength: 256,  search: SalesAreaSearch, profileId: "default", searchCondition: {}}
        },
        ALL_SALES_AREAS: {
            type: SearchProviderFieldType.string,
            renderOptions: { columnName: 'Sales Area',   columnResourceName: 'colCustSalesArea',      alignment: HorizAlignment.Left},
            domainOptions: { maxLength: 256}
        },
        CUSTOMER_TYPES: {
            type: SearchProviderFieldType.string,
            renderOptions: { columnName: 'Customer Type',   columnResourceName: 'colCustTypes',      alignment: HorizAlignment.Left},
            domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
        },
        CREATED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Created Date',
                columnResourceName: 'colCreateDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        },
        MODIFIED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Modified Date',
                columnResourceName: 'colModifiedDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        },
        WB_MDSET_ID:              {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'MDSET ID', columnResourceName: 'colMDSetId', alignment: HorizAlignment.Center}, domainOptions: {}}

    }

const vUI_Planning_Customer_Search_Fields: {[id:string]: ISearchProviderField } =
    {
        WB_CUST_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Customer WB Id',  columnResourceName: 'colCustWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
        CUSTOMER_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Id',     columnResourceName: 'colCustId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        CUSTOMER_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Name',   columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
        CUSTOMER_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, domainIds: 'Customer_Type', useIdAsKey: true}},
        SOURCE_ID:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Id',       columnResourceName: 'colSourceId',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, source: true, useIdAsKey: true }},
        CREATED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Created Date',
                columnResourceName: 'colCreateDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        },
        MODIFIED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Modified Date',
                columnResourceName: 'colModifiedDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        },
        SALESORG: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'SalesOrg',     columnResourceName: 'colSalesOrg',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}}
    }


const vUI_Customer_Search_Error_Records: {[id:string]: ISearchProviderField } = {
    WB_CUST_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Customer ID',  columnResourceName: 'colCustWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
    CUSTOMER_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Name',   columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    CUSTOMER_ID:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer ID',           columnResourceName: 'colId',         alignment: HorizAlignment.Left},   domainOptions: { }},
    CUSTOMER_ID_PRNT:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer ID Parent',        columnResourceName: 'colCustomerIdPrnt',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
    CUSTOMER_NAME_PRNT:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Name Parent',        columnResourceName: 'colCustomerIdPrnt',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
    EFFECTIVE_START_DT:  {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Effective Start Date',    columnResourceName: 'colEffectiveStartDate',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
    EFFECTIVE_END_DT: {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Effective End Date',    columnResourceName: 'colEffectiveEndDate',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
    ERROR_REASON: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Error',    columnResourceName: 'ErrorReason',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
    CUSTOMER_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, domainIds: 'Customer_Type', useIdAsKey: true}},
    SOURCE_ID:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Id',       columnResourceName: 'colSourceId',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, source: true, useIdAsKey: true }},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }

}

var vUI_Wholesaler_Search_Error_Fields: {[id:string]: ISearchProviderField } = {
    WB_CUST_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CUSTOMER_ID:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer ID',           columnResourceName: 'colId',         alignment: HorizAlignment.Left},   domainOptions: { }},
    CUSTOMER_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer Name', columnResourceName: 'colCustomerName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    RELATIONTYPE:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Relation Type', columnResourceName: 'colRelationType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CUSTOMER_ID_REL:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer ID Relation', columnResourceName: 'colCustomerIdRel', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CUSTOMER_NAME_REL:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer Name Relation', columnResourceName: 'colCustomerNameRel', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_GROUP_ID:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group ID', columnResourceName: 'colProductGroupId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_GROUP_NAME:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Group Name', columnResourceName: 'colProductGroupName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    EFFECTIVE_START_DT:            {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective Start Date', columnResourceName: 'colEffectiveStartDate',  alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy"}, domainOptions: { maxLength: 50}},
    EFFECTIVE_END_DT: {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective End Date', columnResourceName: 'colEffectiveEndDate',  alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy"}, domainOptions: { maxLength: 50}},
    ERROR_REASON:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Error', columnResourceName: 'colErrorReason', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 1}},
    CUSTOMER_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, domainIds: 'Customer_Type', useIdAsKey: true}},
    SOURCE_ID:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Id',       columnResourceName: 'colSourceId',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, source: true, useIdAsKey: true }},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }

}

var vUI_BillTo_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_CUST_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CHILD_CUSTOMER_ID:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Child Customer ID', columnResourceName: 'colChildCustomerId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CHILD_CUSTOMER_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Child Customer Name', columnResourceName: 'colChildCustomerName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CHILD_CUSTOMER_TYPE:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Child Customer Type', columnResourceName: 'colChildCustomerType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PARENT_CUSTOMER_ID:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Parent Customer ID', columnResourceName: 'colParentCustomerId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PARENT_CUSTOMER_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Parent Customer Name', columnResourceName: 'colParentCustomerName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PARENT_CUSTOMER_TYPE:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Parent Customer Type', columnResourceName: 'colParentCustomerType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CUSTOMER_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Id',     columnResourceName: 'colCustId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
    CUSTOMER_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Name',   columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    CUSTOMER_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, domainIds: 'Customer_Type', useIdAsKey: true}},
    SOURCE_ID:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Id',       columnResourceName: 'colSourceId',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, source: true, useIdAsKey: true }}

}

const vUI_CustomerControl_MultipleParents: {[id:string]: ISearchProviderField } = {
    WB_CUST_ID:              {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CUSTOMER_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer ID', columnResourceName: 'colCustomerID', alignment: HorizAlignment.Left}, domainOptions: {}},
    CUSTOMER_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer Name', columnResourceName: 'colCustomerName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    WB_CUST_HIER_ID:         {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Hier ID', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: {}},
    WB_CUST_HIER_NAME:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Hier Name', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: {}},
    PARENT_CUSTOMER_ID:      {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Parent Customer ID', columnResourceName: 'colParentCustomerId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PARENT_CUSTOMER_NAME:    {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Parent Customer Name', columnResourceName: 'colParentCustomerName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    EFFECTIVE_START_DT:      {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective Start Date', columnResourceName: 'colEffectiveStartDate', alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy" }, domainOptions: { maxLength: 50}},
    EFFECTIVE_END_DT:        {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective End Date', columnResourceName: 'colEffectiveEndDate',  alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy" }, domainOptions: { maxLength: 50}},
    CUSTOMER_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, domainIds: 'Customer_Type', useIdAsKey: true}},
    SOURCE_ID:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Id',       columnResourceName: 'colSourceId',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50, source: true, useIdAsKey: true }},
    WB_MDSET_ID:              {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'MDSET ID', columnResourceName: 'colMDSetId', alignment: HorizAlignment.Center}, domainOptions: {}}

};

const vUI_CustomerControl_PlanPPG: {[id:string]: ISearchProviderField } = {
    WB_PLAN_ID:              {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PLAN_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Plan ID', columnResourceName: 'colPlanID', alignment: HorizAlignment.Left}, domainOptions: {}},
    PLAN_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Plan Name', columnResourceName: 'colPlanName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PLANNING_LEVEL_ID:         {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Planning Level ID', columnResourceName: 'colPlanningLevelId', alignment: HorizAlignment.Left}, domainOptions: {}},
    PLANNING_LEVEL_NAME:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Planning Level Name', columnResourceName: 'colPlanningLevelName', alignment: HorizAlignment.Left}, domainOptions: {}},
    INSTORE_START_DT:      {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'InStore Start Date', columnResourceName: 'colInStoreStartDate', alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy"}, domainOptions: { maxLength: 50}},
    INSTORE_END_DT:        {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'InStore End Date', columnResourceName: 'colInStoreEndDate', alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy"}, domainOptions: { maxLength: 50}},
};



const CustomerSearchProviderBasic: ISearchProvider =
    {
        keyFields: {id:    'WB_CUST_ID',
            id_ui: 'CUSTOMER_ID',
            name:  'CUSTOMER_NAME'},


        searchProviderFields: vUI_Customer_Search_Fields,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_Customer_Search',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        let returnVals: any[] = _.uniqBy(res, aRes => aRes.WB_CUST_ID)
                        resolve(returnVals)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        },

        distinctValues(fieldName: string): Promise<string[] | number[]> {
            return new Promise<string[] | number[]>((resolve, error) => {
                let findRequest = SearchUtils.makeSearchRequest({},
                    'vUI_Customer_Search',
                    this.searchProviderFields,
                    [fieldName])


                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(_.map(res, (aRow) => {
                            return aRow[fieldName]
                        }))
                    })
                    .catch((err) => {
                        error(err)
                    })
            })
        }

    }

const CustomerSearchProviderPlanned: ISearchProvider = {

    keyFields: {id:    'WB_CUST_ID',
        id_ui: 'CUSTOMER_ID',
        name:  'CUSTOMER_NAME'},

    searchProviderFields: vUI_Planning_Customer_Search_Fields,

    async search(searchOptions: ISearchRequestSubset): Promise<any[]> {
      //  return new Promise<any[]>((resolve, error) => {

            let dbContext = new Mdl.Core.DbContext()
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            // if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchOptions.where['SALESORG'] = {inq: _.map(usrContext.WB_SalesOrgs, 'SALESORG_ID')}
            // }
            // else{
            //     let allSalesOrgs = await dbContext.findAll(Mdl.Core.DbSchema.esWB_SalesOrg, {DELETED_IND :{nin: ['1']}})
            //     // @ts-ignore
            //     searchOptions.where['SALESORG'] ={inq: _.map(allSalesOrgs,'SALESORG_NAME')}
            //     // searchOptions.limit=1000
            // }
                // searchOptions.where['SALESORG'] ={inq: _.map(esWB_SalesOrg,)}
        console.log(searchOptions)
            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Cust_Plan_Search',
                this.searchProviderFields,
                ['WB_CUST_ID','CUSTOMER_NAME', 'CUSTOMER_ID'])


       if (!usrContext.hasRoleId("VIEW_ALL"))
            SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID')

           return PASearch.findByRequest(findRequest)
                // .then((res: any[]) => {
                //     resolve(res)
                // })
                // .catch((err)=> {
                //     error(err)
                // })
       // })
    }




}

const MyPlanningCustomerSearchProvider: ISearchProvider = {

    keyFields: {id:    'WB_CUST_ID',
        id_ui: 'CUSTOMER_ID',
        name:  'CUSTOMER_NAME'},


    searchProviderFields: vUI_Customer_Search_Fields,

    search(aRequestSubset: ISearchRequestSubset): Promise<any[]> {

        return new Promise<any[]>((resolve, error) => {

            let findRequest: ISearchRequest
                = SearchUtils.makeSearchRequest(aRequestSubset,
                'vUI_Customer_Search',
                this.searchProviderFields)

            SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID')

            PASearch.findByRequest(findRequest)
                .then((results: any[]) => {
                    resolve(results)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}

const CustomerSearchProviderBasicErrorRecords: ISearchProvider =
    {
        keyFields: {id:    'WB_CUST_ID',
            id_ui: 'CUSTOMER_ID',
            name:  'CUSTOMER_NAME'},


        searchProviderFields: vUI_Customer_Search_Error_Records,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vWB_CustR_Dup',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }

const CustomerBillToRecords: ISearchProvider =
    {
        keyFields: {id:    'WB_CUST_ID',
            id_ui: 'CUSTOMER_ID',
            name:  'CUSTOMER_NAME'},


        searchProviderFields: vUI_BillTo_Search_Fields,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_Customer_BillTo_Search1',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }

const CustomerSearchProviderBasicControlMultipleParents: ISearchProvider =
    {
        keyFields: {id:    'WB_CUST_ID',
            id_ui: 'CUSTOMER_ID',
            name:  'CUSTOMER_NAME'},


        searchProviderFields: vUI_CustomerControl_MultipleParents,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_CustomerControl_MultipleParents1',
                    this.searchProviderFields,
                    [])

                findRequest.order = ['CUSTOMER_NAME'];

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }



const CustomerSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "CustomerSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Customer Id',      searchProviderFieldId: 'CUSTOMER_ID',       renderOptions: { }},
        {profileFilterName: 'Customer Name',    searchProviderFieldId: 'CUSTOMER_NAME',     renderOptions: { }},
        {profileFilterName: 'Customer Type',    searchProviderFieldId: 'CUSTOMER_TYPE',    renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Sales Area',       searchProviderFieldId: 'WB_SALESAREA_ID',   bMultiSelect: true, renderOptions: { }},
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','CUSTOMER_TYPES','ALL_SALES_AREAS', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerSearchProviderBasic,

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
    ],
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

var WholesalerSearchProviderErrorRecords: ISearchProvider = {

    keyFields: {id:    'WB_CUST_ID',
        id_ui: 'CUSTOMER_ID',
        name:  'CUSTOMER_NAME'},

    searchProviderFields: vUI_Wholesaler_Search_Error_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vCustRPG_Validation',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const MyPlanningCustomers: ISearchProfile = {
    profileId: "MyPlanningCustomers",
    profileName: "My Planning Customers",
    renderOptions: { ui5ResourceId: "MyPlanningCustomers" },

    profileFilter: [
        {profileFilterName: 'Customer Id',     searchProviderFieldId: 'CUSTOMER_ID',   renderOptions: { }},
        {profileFilterName: 'Customer Name',   searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: { }},
        {profileFilterName: 'Customer Level',  searchProviderFieldId: 'CUSTOMER_TYPE', renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Source',          searchProviderFieldId: 'SOURCE_ID',     renderOptions: {  }, bMultiSelect: true},
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerSearchProviderPlanned,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const CustomerSearchProfileByWholeSaler: ISearchProfile = {
    profileId: "ByWholeSaler",
    profileName: "Search by Whole Saler",
    renderOptions: { ui5ResourceId: "CustomerSearchProfileByWholeSaler" },

    profileFilter: [
        {profileFilterName: 'Customer Id',     searchProviderFieldId: 'CUSTOMER_ID',   renderOptions: { }},
        {profileFilterName: 'Customer Name',   searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: { }},
        {profileFilterName: 'Customer Level',  searchProviderFieldId: 'CUSTOMER_TYPE', renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Source',          searchProviderFieldId: 'SOURCE_ID',     renderOptions: {  }, bMultiSelect: true},
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','CUSTOMER_TYPE','WB_CUSTRPG_ID', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const CustomerSearchProfileByErrorRecords: ISearchProfile = {
    profileId: "ByErrorRecords",
    profileName: "Error Records - Customer",
    renderOptions: { ui5ResourceId: "CustomerSearchProfileByErrorRecords" },

    profileFilter: [
        {profileFilterName: 'Customer Id',     searchProviderFieldId: 'CUSTOMER_ID',   renderOptions: { }},
        {profileFilterName: 'Customer Name',   searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: { }},
        {profileFilterName: 'Customer Level',  searchProviderFieldId: 'CUSTOMER_TYPE', renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Source',          searchProviderFieldId: 'SOURCE_ID',     renderOptions: {  }, bMultiSelect: true},

    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','CUSTOMER_ID_PRNT','CUSTOMER_NAME_PRNT','EFFECTIVE_START_DT','EFFECTIVE_END_DT','ERROR_REASON'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerSearchProviderBasicErrorRecords,

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
    ],
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

var WholesalerSearchProfileByErrorRecords: ISearchProfile = {
    profileId: "ByErrors",
    profileName: "Error Records - Wholesaler",
    renderOptions: { ui5ResourceId: "WholesalerSearchProfileByErrorRecords" },

    profileFilter: [
        {profileFilterName: 'Customer Id',     searchProviderFieldId: 'CUSTOMER_ID',   renderOptions: { }},
        {profileFilterName: 'Customer Name',   searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: { }},
        {profileFilterName: 'Customer Level',  searchProviderFieldId: 'CUSTOMER_TYPE', renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Source',          searchProviderFieldId: 'SOURCE_ID',     renderOptions: {  }, bMultiSelect: true},
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','CUSTOMER_ID_REL','RELATIONTYPE','CUSTOMER_NAME_REL','PRODUCT_GROUP_ID','PRODUCT_GROUP_NAME','EFFECTIVE_START_DT','EFFECTIVE_END_DT','ERROR_REASON', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: WholesalerSearchProviderErrorRecords,

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
    ],
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const BillToSearch: ISearchProfile = {
    profileId: "ByBillTo",
    profileName: "Search by Bill-To",
    renderOptions: { ui5ResourceId: "BillToSearch" },

    profileFilter: [
        {profileFilterName: 'Customer Id',     searchProviderFieldId: 'CUSTOMER_ID',   renderOptions: { }},
        {profileFilterName: 'Customer Name',   searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: { }},
        {profileFilterName: 'Customer Level',  searchProviderFieldId: 'CUSTOMER_TYPE', renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Source',          searchProviderFieldId: 'SOURCE_ID',     renderOptions: {  }, bMultiSelect: true},
    ],  // ISearchFields
    profileDisplayFields: [
        'CHILD_CUSTOMER_ID','CHILD_CUSTOMER_NAME','CHILD_CUSTOMER_TYPE','PARENT_CUSTOMER_ID','PARENT_CUSTOMER_NAME','PARENT_CUSTOMER_TYPE'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerBillToRecords,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const CustomerSearchProfileByControlMultipleParents: ISearchProfile = {
    profileId: 'ControlMultipleParents',
    profileName: "Control Multiple Parents - Customer",
    renderOptions: { ui5ResourceId: "CustomerSearchProfileByControlMultipleParents"},

    profileFilter: [
        {profileFilterName: 'Customer Id',     searchProviderFieldId: 'CUSTOMER_ID',   renderOptions: { }},
        {profileFilterName: 'Customer Name',   searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: { }},
        {profileFilterName: 'Customer Level',  searchProviderFieldId: 'CUSTOMER_TYPE', renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Source',          searchProviderFieldId: 'SOURCE_ID',     renderOptions: {  }, bMultiSelect: true},
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','WB_CUST_HIER_ID', 'PARENT_CUSTOMER_ID', 'PARENT_CUSTOMER_NAME', 'EFFECTIVE_START_DT', 'EFFECTIVE_END_DT'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerSearchProviderBasicControlMultipleParents,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};


const CustomerSearch: ISearch = {
    searchName: "Find Customer",
    renderOptions: { ui5ResourceId: "CustomerSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [CustomerSearchProfileByName, MyPlanningCustomers,
        CustomerSearchProfileByWholeSaler, CustomerSearchProfileByErrorRecords,
        WholesalerSearchProfileByErrorRecords,BillToSearch,
        CustomerSearchProfileByControlMultipleParents]

}

PAEnvironment.registerBusinessObjectSearch("CustomerBO", "Customer", CustomerSearch, "Customer Search")

export {CustomerSearch}

